<app-navbar>
	<a routerLink="/tourism-calendar/" class="btn btn-danger"> <i class="far fa-calendar-alt"></i> Kalendarz </a>
</app-navbar>
<div class="container row mt-4">
	<div class="d-grid gap-4 col-6 mx-auto">
		<h3>Wybierz kategorię wydarzenia:</h3>
		<a routerLink="./stop" class="btn btn-primary btn-lg">Postój</a>
		<a routerLink="./empty" class="btn btn-primary btn-lg">Przejazd na pusto</a>
		<a routerLink="./RENT/rent" class="btn btn-primary btn-lg">Wynajem</a>
		<a routerLink="./GROUP/rent" class="btn btn-primary btn-lg">Wynajem Grupa</a>
		<a routerLink="./FOREIGN/rent" class="btn btn-primary btn-lg">Wynajem Grupa LDC</a>
		<a routerLink="./FOREIGN_SCANDINAVIA/rent" class="btn btn-primary btn-lg">Wynajem Grupa LDC Skandynawia</a>
		<a routerLink="./service" class="btn btn-primary btn-lg">Serwis</a>
		<a routerLink="./duty" class="btn btn-primary btn-lg">Dyżur</a>
		<a routerLink="./fleet" class="btn btn-primary btn-lg">Flota</a>
		<a routerLink="./technical-empty" class="btn btn-primary btn-lg">Przejazd techniczny na pusto</a>
		<a routerLink="./antenna-bus" class="btn btn-primary btn-lg">Antenka autokar</a>
		<a routerLink="./accident" class="btn btn-primary btn-lg">Awaria</a>
		<a routerLink="./wash" class="btn btn-primary btn-lg">Myjnia</a>
		<a routerLink="./full" class="btn btn-primary btn-lg">Inne</a>
	</div>
</div>
